import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout route: the stub landing page moved to `warehouse/index.tsx` so the
// section can host sub-pages (containers, ...).
export const Route = createFileRoute('/_protected/warehouse')({
  component: () => <Outlet />,
})
